// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__cHtHM","lg":"SectionTitle_lg__PoaQZ","md":"SectionTitle_md__G8Ynn"};